module.exports = __webpack_public_path__ + "img/bull_main_mo.3934e6cf.gif";